import chroma from 'chroma-js';


export const updateLayerOrder = (map, layerNames) => {
  if (!Array.isArray(layerNames) || layerNames.length < 2) {
    console.warn('Please provide an array of at least two layer names.');
    return false;
  }

  // Filter out any layers that do not exist in the map
  const existingLayers = layerNames.filter(layerName => map.getLayer(layerName));

  if (existingLayers.length < 2) {
    console.warn('Not enough valid layers to reorder.');
    return false;
  }


  // Log the original order of layers
  const originalOrder = existingLayers.map(layerName => ({
    name: layerName,
    index: map.getStyle().layers.findIndex(layer => layer.id === layerName),
  }));
  // console.log('Original order of layers:', originalOrder);


  // Reorder the existing layers
  for (let i = 0; i < existingLayers.length - 1; i++) {
    const lowerLayerName = existingLayers[i];
    const upperLayerName = existingLayers[i + 1];

    // Move lowerLayerName to be directly before upperLayerName
    // console.log(`Moving layer ${lowerLayerName} before layer ${upperLayerName}`);
    map.moveLayer(lowerLayerName, upperLayerName);
  }

  // Log the final order of layers
  const finalOrder = existingLayers.map(layerName => ({
    name: layerName,
    index: map.getStyle().layers.findIndex(layer => layer.id === layerName),
  }));
  // console.log('Final order of layers:', finalOrder);


  // Compare the original order with the final order to determine if reordering happened
  const reordered = originalOrder.some((layer, index) => layer.index !== finalOrder[index].index);

  return reordered;
};



function getDistanceFromLatLng(lat1, lng1, lat2, lng2) {
  function toRad(value) {
    return (value * Math.PI) / 180;
  }

  const R = 6371; // Radius of the earth in km
  const dLat = toRad(lat2 - lat1);
  const dLng = toRad(lng2 - lng1);
  const a =
    Math.sin(dLat / 2) * Math.sin(dLat / 2) +
    Math.cos(toRad(lat1)) * Math.cos(toRad(lat2)) *
    Math.sin(dLng / 2) * Math.sin(dLng / 2);
  const c = 2 * Math.atan2(Math.sqrt(a), Math.sqrt(1 - a));
  const distance = R * c; // Distance in km
  return distance;
}

export const getLineBackground = (contentData, speedMax) => {
  const range = chroma.scale(['green', 'yellow', 'red']).domain([0, speedMax]);

  const values = contentData;
  const colorsData = [];

  // Calculate the total distance of the route
  const totalDistance = values.reduce((total, currentPoint, index) => {
    if (index < values.length - 1) {
      return total + getDistanceFromLatLng(
        currentPoint.positionGps_latitude,
        currentPoint.positionGps_longitude,
        values[index + 1].positionGps_latitude,
        values[index + 1].positionGps_longitude
      );
    }
    return total;
  }, 0);

  let accumulatedDistance = 0;

  // Calculate color stops based on distance and speed
  values.forEach((item, index) => {
    if (index < values.length - 1) {
      const nextPoint = values[index + 1];
      const segmentDistance = getDistanceFromLatLng(
        item.positionGps_latitude,
        item.positionGps_longitude,
        nextPoint.positionGps_latitude,
        nextPoint.positionGps_longitude
      );

      accumulatedDistance += segmentDistance;

      const progress = accumulatedDistance / totalDistance;

      // Map the speed to a color using speedMax as the upper bound
      const speed = typeof item.speed === 'number' ? Math.max(0, Math.min(item.speed, speedMax)) : 0;
      const color = range(speed).hex();

      // Add the progress and color to the colorsData array only if it's not a duplicate
      if (colorsData.length === 0 || colorsData[colorsData.length - 2] !== progress) {
        colorsData.push(progress, color);
      }
    }
  });

  // Check if the "1" progress value is already in the array before adding it
  if (colorsData[colorsData.length - 2] !== 1) {
    colorsData.push(1, range(values[values.length - 1].speed).hex());
  }

  return colorsData;
};

